import { useTranslation } from 'react-i18next';

import { DataItem, NgButton } from '@/ui';
import { humanizeDate } from '@ngsos/portal-core/time';
import type { PortalCall } from '@/signalr/contracts';
import { MarkerHeader } from '@/features/shared/map/MarkerHeader';

export type CallNotificationsDetailTemplateProps = {
  item: PortalCall;
  hasLinkedIncident: boolean;
  onOpenOrCreateIncident: (item: PortalCall) => void | Promise<void>;
};

export function CallNotificationsDetailTemplate({
  item,
  hasLinkedIncident,
  onOpenOrCreateIncident,
}: CallNotificationsDetailTemplateProps) {
  const { t, i18n } = useTranslation();

  return (
    <div className="d-flex flex-column gap-2" style={{ width: 300 }}>
      <MarkerHeader title={item.callerPhoneNumber} iconUrl="/Images/Icons/map-caller.svg" />

      <DataItem title={t('Label_UpdateTime')} value={humanizeDate(item.startedAtUtc, i18n.language || 'en')} />

      <div className="d-flex justify-content-center gap-2">
        <NgButton
          onClick={() => void onOpenOrCreateIncident(item)}
          size="small"
          showProgress
          icon={hasLinkedIncident ? 'fal fa-arrow-up-right-from-square' : 'fal fa-circle-plus'}
          cssClass="d-flex flex-row align-items-center"
        >
          {t(hasLinkedIncident ? 'Button_Open' : 'CallNotification_Button_CreateIncident')}
        </NgButton>
      </div>
    </div>
  );
}
